import { isSafari, parseDataSelector, setEventDelay } from "./kdHelp"

/**
 * класс управления вертикальной полосой прокрутки элемента (по умолчанию - тега body)
 * scrollbar - здесь и далее - полоса прокрутки элемента
 * 
 * @version 1.0.1
 * @constructor
 * @param {object} options - объект опций
 * @returns {Scrollbar} экземпляр класса
 */
class Scrollbar {
    constructor(element = null, options = {}) {
        if ( typeof window.scrollbar !== 'undefined' ) {
            window.scrollbar
        }
        let default_options = {
            cap_color: 'rgba(0,0,0,.3)',
            cap_data_selector: '[data-element="cap"]'
        }
        this.options = { ...default_options, ...options }
        this.element = (element === null) ? document.body : element
        this.cap = null

        let resize_handler = () => {
            if (this.cap) {
                this.cap.updateWidth()
            }
        }
        window.addEventListener('resize', setEventDelay(event, resize_handler, 300, false))

        // заносим в глобальную переменную
        window.scrollbar = this
    }

    /**
     * получить размер scrollbar в px.
     *
     * @param {boolean} hard - получить размер спрятанного scrollbar
     * @returns {number} scrollbar_width - ширина scrollbar в пикселах
     */
    _getScrollbarWidth(hard = false) {
        if (isSafari()) return 0
        return window.innerWidth - document.documentElement.clientWidth
    }

    /**
     * показывает, существует ли в данный момент вертикальная полоса прокрутки
     *
     * @returns {boolean} status - статус
     */
    _scrollExists() {
        return !!(window.innerWidth - document.documentElement.clientWidth)
    }

    /**
     * создает и вставляет в DOM элемент заглушки
     *
     * @private
     * @param {string} styleDisplay - значение css свойства display элемента
     * @returns {object} cap - заглушка
     */
    _createCap(styleDisplay = 'none') {
        let cap = {}
        cap.element = document.querySelector(this.options.cap_data_selector)

        if (!cap.element) {

            // обработка data селектора
            let [key, value] = parseDataSelector(this.options.cap_data_selector)

            cap.width = this._getScrollbarWidth()
            cap.element = document.createElement('div')
            cap.element.dataset[key] = value
            cap.element.style.backgroundColor = this.options.cap_color
            cap.element.style.display = styleDisplay
            cap.element.style.height = 'calc(var(--vh) * 100)'
            cap.element.style.position = 'fixed'
            cap.element.style.top = '0px'
            cap.element.style.width = cap.width + 'px'
            cap.element.style.right = '0px'
            document.body.append(cap.element)
        }

        cap.show = () => {
            cap.updateWidth()
            cap.element.style.display = 'block'
        }

        cap.hide = () => {
            cap.element.style.display = 'none'
        }

        cap.updateWidth = () => {
            cap.width = this._getScrollbarWidth()
            cap.element.style.width = cap.width + 'px'
        }

        return cap
    }

    /**
     * отключить прокрутку элемента
     *
     * @param {boolean} cap - заменить полосу прокрутки заглушкой. При отсутствии заглушки меняется размер окна
     */
    off(cap = true) {
        if (!this.cap)
            this.cap = this._createCap()
        if (cap) {
            this.cap.show()
            this.element.style.width = `calc(100vw - ${this.cap.width}px)`
            document.documentElement.style.setProperty('--vw', `calc((100vw - ${this.cap.width}px) / 100)`)
        }
        this.element.style.overflow = 'hidden'
    }

    /**
     * включить прокрутку элемента
     */
    on() {
        if (!this.cap)
            this.cap = this._createCap()
        this.cap.hide()
        this.element.style.width = ''
        this.element.style.overflow = ''
        document.documentElement.style.setProperty('--vw', '')
    }
}

export default Scrollbar